import React, { useState } from "react";
import images from "../../assets/image.png";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import AppointmentModal from "../../global/AppointmentModal";
const HomeBanner = () => {
      const [showModal, setShowModal] = useState(false);
      
  return (
    <div className="w-full flex justify-center items-center relative pb-[5rem]">
      <div className="container">
        <div className="w-full flex lg:flex-row flex-col items-center ">
          <div className="lg:w-1/2 w-full mt-[5rem] flex flex-col justify-center items-center">
            <motion.div
              initial={{ opacity: 0.8, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "linear" }}
              className="flex flex-col lg:items-start items-center gap-3 ">
             
              <h2 className="md:text-5xl text-4xl font-bold text-gray-300 leading-tight mb-0 mt-0 lg:text-start text-center">
                স্মার্ট <span className="text-[#22beff]">শিক্ষা</span>, স্মার্ট <span className="text-[#22beff]">বাংলাদেশ</span> আপনার সন্তানকে <span className="text-[#22beff]">রিভাইভ</span> এর জন্য
                COMPLETE সল্যুশন এখানেই !
              </h2>

              <div className="flex sm:items-start gap-4 mt-4">
                <button className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff] bg-[#22beff] text-[#081a28] rounded-md font-medium cursor-pointer  hover:text-white" onClick={() => setShowModal(true)}>
                  অ্যাপয়েন্টমেন্ট
                </button>

                <Link
                  to="/qs-academy/home/details"
                  className="px-[1.25rem] py-[0.8rem] text-base border border-[#22beff]  text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff] rounded-md font-medium cursor-pointer"
                >
                  বিস্তারিত পড়ুন
                </Link>
              </div>
            </motion.div>
          </div>
          <div className="lg:w-1/2 w-full lg:mt-0 mt-[1rem] ">
            <img src={images} alt="home_banner" />
          </div>
        </div>
      </div>
      <AppointmentModal showModal={showModal} setShowModal={setShowModal}/>
    </div>
  );
};

export default HomeBanner;
